import React, { FC } from 'react';
import { Link, LinkProps, useSearchParams } from 'react-router-dom';

const referrerSearchParam = 'fpr';

const LinkWithReferrerId: FC<LinkProps> = ({ to, ...props }) => {
  const [searchParams] = useSearchParams();
  const refId = searchParams.get(referrerSearchParam);

  const path = refId ? `${to}?${referrerSearchParam}=${refId}` : to;
  return <Link to={path} type="link" {...props} />;
};

export { referrerSearchParam };
export default LinkWithReferrerId;
